let daysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate()
}
export function getCurrentDate() {
  const d = new Date()
  let dd = d.getDate()
  let monthnumber = (d.getMonth() + 1)
  let MM = (monthnumber < 10 ? `0${monthnumber}` : monthnumber)
  let YYYY = d.getFullYear()
  let  date = `${YYYY}-${MM}-${dd}`
  return date
}
export function formatDate (date) {
  if (!!date) {
    // console.log(`date befor format is ${date}`)
    var timestamp = Date.parse(date)
    if (isNaN(timestamp) === false) {
      const d = new Date(date)
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let dd = (d.getDate() < 10 ? '0' : '') + d.getDate()
      let MMM = monthNames[d.getMonth()]
      let YYYY = d.getFullYear().toString()
      date = `${dd}-${MMM}-${YYYY}`
      return date
    } else {
      console.log('invalid date')
    }
  } else {
    return null
  }
}

export function convertDate (date) {
  if (!date) return NaN
  // only accept format 01-Jan-18
  const regex = /^(([1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-1])(-)(Jan|jan|Feb|feb|Mar|mar|Apr|apr|May|may|Jun|jun|Jul|jul|Aug|aug|Sep|sep|Oct|oct|Nov|nov|Dec|dec)(-)(\d{4}))$/gm
  if (date.match(regex) === null) {
    return NaN
  }
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  // split date
  let [day, month, year] = date.split('-')

  // find monthnumber
  month = month.toLowerCase() // set to lower-case anyinput
  month = month.charAt(0).toUpperCase() + month.slice(1)
  let monthnumber = monthNames.indexOf(month) + 1

  day = day < 10 && day.length < 1 ? `0${day}` : day
  monthnumber = monthnumber < 10 ? `0${monthnumber}` : monthnumber

  // validate format day in mounth
  if (daysInMonth(monthnumber, year) < parseInt(day)) {
    return NaN
  }

  date = `${year}-${monthnumber}-${day}`
  return date
}
